import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=a7662f76"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"
import style0 from "./Result.vue?vue&type=style&index=0&id=a7662f76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports